var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIconInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "0.44456cm",
    height: "0.44456cm",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 8.42 8.42",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_2623582475776"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7526FE",
    d: "M0.76 6.15l0 -3.88c0,-0.8 0.72,-1.51 1.51,-1.51l3.88 0c0.8,0 1.51,0.72 1.51,1.51l0 3.88c0,0.8 -0.72,1.51 -1.51,1.51l-3.88 0c-0.8,0 -1.51,-0.72 -1.51,-1.51zm-0.76 -3.96l0 4.05c0,0.26 0.11,0.64 0.22,0.86l0.32 0.5c0.19,0.2 0.15,0.19 0.43,0.4 0.29,0.22 0.84,0.43 1.21,0.43l4.05 0c0.26,0 0.64,-0.11 0.86,-0.22 0.63,-0.32 1.04,-0.79 1.25,-1.48 0.03,-0.12 0.08,-0.33 0.08,-0.48l0 -4.05c0,-0.14 -0.04,-0.35 -0.08,-0.47 -0.16,-0.56 -0.44,-0.95 -0.9,-1.29 -0.2,-0.15 -0.49,-0.28 -0.74,-0.35 -0.12,-0.03 -0.33,-0.08 -0.48,-0.08l-4.05 0c-0.14,0 -0.35,0.04 -0.47,0.08 -0.25,0.07 -0.54,0.2 -0.74,0.35 -0.06,0.04 -0.1,0.08 -0.16,0.12l-0.27 0.27c-0.3,0.32 -0.55,0.94 -0.55,1.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7526FE",
    d: "M2.8 4.28c0,-0.34 0.06,-0.62 0.25,-0.88 0.25,-0.34 0.67,-0.6 1.1,-0.6 0.45,0 0.76,0.11 1.06,0.42 0.11,0.11 0.22,0.24 0.28,0.39 0.18,0.45 0.18,0.76 0,1.21 -0.1,0.26 -0.43,0.57 -0.67,0.67 -0.45,0.18 -0.76,0.18 -1.21,0 -0.2,-0.08 -0.42,-0.29 -0.55,-0.46 -0.14,-0.19 -0.26,-0.51 -0.26,-0.76zm-0.76 -0.18c0,0.27 -0.01,0.4 0.07,0.67 0.06,0.24 0.19,0.5 0.33,0.69 0.22,0.32 0.49,0.53 0.84,0.71 0.12,0.06 0.23,0.1 0.37,0.14 0.35,0.1 0.78,0.1 1.12,0 0.49,-0.13 0.92,-0.43 1.21,-0.84 0.08,-0.1 0.13,-0.21 0.19,-0.32 0.59,-1.17 -0.04,-2.65 -1.39,-3.03 -0.62,-0.18 -1.3,-0.05 -1.82,0.32 -0.19,0.14 -0.38,0.32 -0.52,0.52 -0.21,0.29 -0.4,0.77 -0.4,1.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7526FE",
    d: "M5.92 1.94c0,0.18 0.05,0.29 0.15,0.39 0.05,0.05 0.06,0.07 0.14,0.11 0.39,0.19 0.81,-0.07 0.81,-0.5 0,-0.3 -0.26,-0.53 -0.54,-0.54 -0.17,-0 -0.32,0.08 -0.41,0.18l-0.1 0.14c-0.03,0.06 -0.05,0.14 -0.05,0.23z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIconInstagram);
export default __webpack_public_path__ + "static/media/homeIconInstagram.c046de32ff0e02e10b60cb00a568741b.svg";
export { ForwardRef as ReactComponent };